$(document).ready(function () {
  $(document).on('turbolinks:load', function () {

  });

  $(document).on('click', '.input-group-append', function () {
    var icon = $(this).find('.toggle-password');
    if (icon.length > 0) {
      icon.toggleClass('fa-eye fa-eye-slash');
      var input = $(this).closest('.input-group').find('input');
      if (input.attr('type') === 'password') {
        input.attr('type', 'text');
      } else {
        input.attr('type', 'password');
      }
    }
  });
});

$(function () {
  var flashCallback;
  flashCallback = function () {
    return $(".alert.auto-hide").slideUp('slow');
  };
  $(".alert.auto-hide").bind('click', function (ev) {
    return $(".alert.auto-hide").slideUp('slow');
  });
  setTimeout(flashCallback, 48000);
  flashCallback
});
